/* A reader-facing prose field as paragraphs (2 Aug 2026, Rob: the long ones
   are hard to read as one block).

   The corpus writes these in folded YAML, where a wrapped line is already
   folded to a space by the time anything here sees it. So a newline that
   survives into the value is never someone's editor wrapping: it is a blank
   line somebody typed on purpose, and it is the only paragraph mark there is.
   That is why one newline is enough to split, and why the count of them does
   not matter. */
export function paragraphs(text: string): string[] {
  return text
    .split(/\n+/)
    .map((p) => p.replace(/[ \t]+/g, " ").trim())
    .filter(Boolean);
}

/* Some of the corpus is written to us rather than to a reader. Sources carry
   "LANE SOURCE OUTSTANDING" where a citation is still owed, and the question
   prose fields carry editorial notes: at the 2 Aug 2026 audit, 44 of 193
   population caveats and 51 of 193 "what would settle it" fields mentioned
   the mockup, the dossier, or the lanes by name. Inside the app that reads as
   a working note. On a page built to be posted in public it reads as us
   talking to ourselves in front of strangers, so anything carrying a marker
   is dropped rather than shown.

   Deliberately trigger-happy: losing a paragraph costs a reader nothing, and
   the failure in the other direction is the one that cannot be taken back.
   The real fix is in the corpus, not here.

   Moved here from the landing route on 2 Aug 2026, when the illustration
   manifest needed the same judgement: the brief handed to the image agent is
   built from these fields, and a note about the dossier is no better as
   instructions to an illustrator than it is as copy for a reader. Two callers
   now, so the rule lives with the other prose helpers rather than inside a
   route. As of that move the corpus is clean and this drops nothing; it is
   here for the next import, not for today's. */
const INTERNAL = /\bmockups?\b|\bdossiers?\b|\blanes?\b|\bcrossfire\b|placeholder|outstanding|to be sourced|\bTODO\b|\bTK\b/i;

export function publicProse(text: string | null): string | null {
  if (!text || INTERNAL.test(text)) return null;
  return text;
}
